import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value, size = 16 }) {
  return (
    <span className="inline-flex items-center" aria-label={`${value} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(value) ? "fill-brass text-brass" : "text-line"}
        />
      ))}
    </span>
  );
}
